import { createAPICall } from "src/api";
import { UserSerializer } from "src/serializers";

const url = "/api/v1/users";

const UserAPI = {
  fetchUser: ({ userId = "self", show_inactive = false }) =>
    createAPICall({
      url: `${url}/${userId}`,
      serializer: UserSerializer,
      queryParams: { show_inactive },
    }),
  createUser: (payload) =>
    createAPICall({
      payload,
      url,
      method: "POST",
      serializer: UserSerializer,
    }),
  updateUser: ({ userId, data, show_inactive = false }) =>
    createAPICall({
      url: `${url}/${userId}`,
      body: JSON.stringify(data),
      method: "PATCH",
      serializer: UserSerializer,
      queryParams: { show_inactive },
    }),
  searchUsers: ({ searchTerm }) =>
    createAPICall({
      url,
      queryParams: searchTerm.includes("@")
        ? { filter_emails: searchTerm }
        : { filter_name: searchTerm },
    }),
  setPassword: ({ userId, old_password, new_password }) =>
    createAPICall({
      url: `${url}/${userId}/set_password`,
      body: JSON.stringify({ old_password, password: new_password }),
      method: "PATCH",
    }),
};

export { UserAPI };
